// @flow
import React from 'react';
import Head from 'next/head';

import { RESORT_SEO } from 'Client/cms/toolkit/constants';
import { productSEOTitleResolver } from './productSEOTitle.resolver';

type Props = {|
  title: string,
  meta: $ReadOnlyArray<{ content: string, key?: string, name?: string, property?: string }>,
  script: $ReadOnlyArray<{ type: string, innerHTML: string }>,
|};

export const productSEOTitleDescriptor = {
  name: RESORT_SEO,
  // eslint-disable-next-line clubmed/no-fake-component
  component: ({ title, meta, script }: Props) => (
    <Head>
      <title key="title">{title}</title>
      {meta.map(({ content, key, name, property }) => (
        <meta
          key={key || name || property}
          {...(property ? { property } : { name })}
          content={content}
        />
      ))}
      {script.map(({ type, innerHTML }) => (
        <script
          key="product-seo-title-ld-json"
          type={type}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: innerHTML }}
        />
      ))}
    </Head>
  ),
  props: productSEOTitleResolver.props,
  resolve: productSEOTitleResolver.resolve,
};
